export default "__VITE_ASSET__7zQi779i__"